import { render, staticRenderFns } from "./MultiplePersonsField.vue?vue&type=template&id=179bcaa5&scoped=true&"
import script from "./MultiplePersonsField.vue?vue&type=script&lang=js&"
export * from "./MultiplePersonsField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179bcaa5",
  null
  
)

export default component.exports